import { createAction } from '@wix/communities-blog-client-common';

export const START_EDITING_COMMENT = 'comment/START_EDITING';
export const startEditingComment = createAction(START_EDITING_COMMENT);
